import {mutationTypes} from "@/core/constants";
import {FiltroUtils} from "@/core/utils";

export default {
	[mutationTypes.CONFIGURACAO.FISCAIS.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},
	[mutationTypes.CONFIGURACAO.FISCAIS.RESET_PAGINACAO_LISTAGEM](state) {
		state.paginacao.page = 1
	},
	[mutationTypes.CONFIGURACAO.FISCAIS.SET_FILTRO_LISTAGEM](state, filtro) {
		FiltroUtils.setarFiltro(state.filtro, filtro)
	},
	[mutationTypes.CONFIGURACAO.FISCAIS.RESET_FILTRO_LISTAGEM](state) {
		FiltroUtils.limparFiltroAvancado(state.filtro)
	},
}
